


export type FlowRoleType = 'AccountingPermission' | 'ApprovalDuty' | 'FinalControlPermission';

export const FlowRoleType = {
    AccountingPermission: 'AccountingPermission' as FlowRoleType,
    ApprovalDuty: 'ApprovalDuty' as FlowRoleType,
    FinalControlPermission: 'FinalControlPermission' as FlowRoleType
};

